import { GET_PARTNER_DATA, GET_PARTNER_LOAD, GET_PARTNER_ERROR } from '../actionTypes';

const INITIAL_STATE = {
  data: {
    data: []
  },
  load: false,
  error: null,
};

export const getPartnersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PARTNER_DATA: {
      return {
        ...state,
        data: action.data,
      };
    }
    case GET_PARTNER_LOAD: {
      return {
        ...state,
        load: action.load,
      };
    }
    case GET_PARTNER_ERROR: {
      return {
        ...state,
        error: action.error,
      }
    }
    default:
      return state;
  }
}
